import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import classNames from 'classnames';
import useResizeObserver from 'use-resize-observer';
import { CardContent } from './Card.Content/Card.Content.es.js';
import { CardFooter } from './Card.Footer/Card.Footer.es.js';

const Card = ({ variant = 'primary/base', clickable = false, disabled = false, warning = false, selected = false, className, children, ...rest })=>{
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [type, size] = useMemo(()=>variant.split('/'), [
        variant
    ]);
    const { ref } = useResizeObserver({
        onResize: ({ width, height })=>{
            if (width === undefined || height === undefined) return;
            setWidth(width);
            setHeight(height);
        }
    });
    return jsxs("div", {
        ref: ref,
        className: classNames('cb-card', type, size, {
            clickable,
            disabled,
            selected,
            warning
        }, className),
        ...rest,
        children: [
            type === 'dashed' && jsx("svg", {
                className: "dashed-graphic",
                "data-testid": "dashed",
                fill: "none",
                viewBox: `0 0 ${width} ${height}`,
                xmlns: "http://www.w3.org/2000/svg",
                children: jsx("rect", {
                    className: "stroke-current",
                    height: height,
                    rx: size === 'sm' ? '6' : '12',
                    strokeDasharray: "10 10",
                    width: width,
                    x: "0.5",
                    y: "0.5"
                })
            }),
            children
        ]
    });
};
Card.displayName = 'Card';
Card.Content = CardContent;
Card.Footer = CardFooter;

export { Card, Card as default };
//# sourceMappingURL=Card.es.js.map
